class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.loadMoreBtn = this.querySelector('.load-more-btn');
    this.container = document.querySelector('[data-next-url]');
    this.currentViewCountEl = this.querySelector('.current-view-count');
    this.totalCount = parseInt(this.querySelector('.total-count').textContent);
    this.currentViewProgressEl = this.querySelector('.current-view-progress');

    document.addEventListener('DOMContentLoaded', this.updateDetails.bind(this));
    if (this.loadMoreBtn) this.loadMoreBtn.addEventListener('click', this.onBtnClick.bind(this));
  }

  onBtnClick() {
    const url = this.container.dataset.nextUrl;

    // 1. Start loading
    this.loadMoreBtn.classList.add('loading');

    fetch(url, {method: 'GET'})
    .then(response => response.text())
    .then(responseText => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const nextPageContainer = html.querySelector('[data-next-url]');

      // 2. Add next page content
      this.container.insertAdjacentHTML('beforeend', nextPageContainer.innerHTML);

      // 3. Update data-next-url attribute
      this.container.dataset.nextUrl = nextPageContainer.dataset.nextUrl;

      // 4. If there's no next url, hide Load More button
      if (!this.container.dataset.nextUrl) this.loadMoreBtn.classList.add('hidden');

      // 5. Update current view count
      this.updateDetails();
    })
    .catch(error => console.log(error))
    .finally(() => {
      // 5. End loading
      this.loadMoreBtn.classList.remove('loading');
    })
  }

  updateDetails() {
    const currentViewCount = this.container.querySelectorAll(':scope > [class*=card]').length;

    // 1. Count
    this.currentViewCountEl.textContent = currentViewCount;

    // 2. Progress
    const percentage = ((currentViewCount / this.totalCount) * 100);
    this.currentViewProgressEl.style.width = `${percentage}%`;
  }

  onFacets() {
    const newContainer =  document.querySelector('[data-next-url]');
    const newCurrentViewCountEl = document.querySelector('.current-view-count');
    const newCurrentViewCount = newContainer.querySelectorAll(':scope > [class*=card]').length;
    const newCurrentViewProgressEl = document.querySelector('.current-view-progress');

    // 1. Count
    newCurrentViewCountEl.textContent = newCurrentViewCount;

    // 2. Progress
    const percentage = ((newCurrentViewCount / this.totalCount) * 100);
    newCurrentViewProgressEl.style.width = `${percentage}%`;
  }
}

customElements.define('load-more', LoadMore);